<template>
  <svg
    v-if="variant === 'default'"
    xmlns="http://www.w3.org/2000/svg"
    width="21.542"
    height="21.971"
    :class="props.iconClass"
    viewBox="0 0 21.542 21.971"
    style="shape-rendering: geometricPrecision; overflow: visible"
  >
    <g id="icon_-_shopping-cart" data-name="icon - shopping-cart">
      <!-- Cart body - restored original path -->
      <path
        d="M3.133,4H19.305l-2,9.329H3.994L2.663,0H0"
        transform="translate(1 1.029)"
        stroke="#991e66"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none"
        style="vector-effect: non-scaling-stroke"
      />
      <!-- Left wheel - Safari-compatible positioning -->
      <circle
        cx="4.664"
        cy="18.001"
        r="1.999"
        stroke="#991e66"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        style="vector-effect: non-scaling-stroke"
      />
      <!-- Right wheel - Safari-compatible positioning -->
      <circle
        cx="17.306"
        cy="18.001"
        r="1.999"
        stroke="#991e66"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        style="vector-effect: non-scaling-stroke"
      />
    </g>
  </svg>

  <svg
    v-else-if="variant === 'dark'"
    xmlns="http://www.w3.org/2000/svg"
    width="26.237"
    height="26.828"
    :class="props.iconClass"
    viewBox="0 0 26.237 26.828"
    style="shape-rendering: geometricPrecision; overflow: visible"
  >
    <g id="icon_-_shopping-cart" data-name="icon - shopping-cart">
      <!-- Cart body - restored original path -->
      <path
        d="M3.895,4.966H24L21.517,16.552H4.966L3.31,0H0"
        transform="translate(1 1)"
        stroke="#333"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none"
        style="vector-effect: non-scaling-stroke"
      />
      <!-- Left wheel - Safari-compatible positioning -->
      <circle
        cx="6.793"
        cy="23.345"
        r="2.483"
        stroke="#333"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        style="vector-effect: non-scaling-stroke"
      />
      <!-- Right wheel - Safari-compatible positioning -->
      <circle
        cx="22.517"
        cy="23.345"
        r="2.483"
        stroke="#333"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        style="vector-effect: non-scaling-stroke"
      />
    </g>
  </svg>
</template>

<script setup lang="ts">
interface Props {
  variant?: "default" | "dark";
  iconClass?: string;
}

const props = withDefaults(defineProps<Props>(), {
  variant: "default",
});
</script>
